
import { ASSET_METADATA } from '../../asset/model/asset.metadata';
import { EntityMetadata, GenericEntityMetadata, PropertyMetadata, RelationshipType, TemporalType, nullIfContainsNull } from '@scisys-uim/uim-common';


export class AssetMaintenanceMetadataBase extends GenericEntityMetadata {
  constructor() {
    super('AssetMaintenance', {
      assetMaintenanceId: <PropertyMetadata> {
        name: 'assetMaintenanceId',
        type: 'number',
        plural: false,
        isIdentity: true,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      asset: <PropertyMetadata> {
        name: 'asset',
        type: 'Asset',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        relationship: true,
        relationshipType: RelationshipType.ManyToOne,
        get relationshipEntityMetadata(): EntityMetadata {
          return ASSET_METADATA;
        },
        byReference: true,
        unique: false
      },
      assetId: <PropertyMetadata> {
        name: 'assetId',
        type: 'number',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      comments: <PropertyMetadata> {
        name: 'comments',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 1000,
        unique: false
      },
      createdBy: <PropertyMetadata> {
        name: 'createdBy',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      createdDate: <PropertyMetadata> {
        name: 'createdDate',
        type: 'Date',
        temporalType: TemporalType.TIMESTAMP,
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      lockVersion: <PropertyMetadata> {
        name: 'lockVersion',
        type: 'number',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      maintenanceBy: <PropertyMetadata> {
        name: 'maintenanceBy',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      maintenanceDate: <PropertyMetadata> {
        name: 'maintenanceDate',
        type: 'Date',
        temporalType: TemporalType.DATE,
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      maintenanceType: <PropertyMetadata> {
        name: 'maintenanceType',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      }
    });
  }
  toKeyObject(item: any): any {
    const result = item?.assetMaintenanceId;
    return nullIfContainsNull(result);
  }
}



